export default {
	data: {
		selectedImageIndex: undefined,
		selectedFacilityImageIndex: undefined
	},
	computed: {
		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		}
	}

};